<div class=" row gamesCarousel gameDisabled_{{gameDisabled}} showtime_{{showtime}}">
  <div class="gamesCarousel--header">
    <h2><span>{{'insta.playGames'|translate}}</span></h2>
    <a href="#" [routerLink]="[showLang ? showLang : 'en', 'games']">{{'insta.showAllGames' | translate }}</a>
  </div>
  <div class="mw xl-12 md-12 sm-12 xs-12 featured-content-container">
    <div class="insta--featured gamesCarousel--container">
    <div class="insta--featured-carousel">

        <owl-carousel *ngIf="featured?.length" [options]="{dotsEach: true, checkVisible: true, mouseDrag: false, margin: 30, autoWidth: false, responsiveClass: true, responsive:{
                                '0':{ items:3, nav: false },
                                '555':{ items:3, nav: false },
                                '820':{ items:4, nav: false },
                                '1200':{ items:5, nav: true }
                                }}"
                      [items]="featured"
                      [carouselClasses]="['owl-carousel','owl-theme','owl-drag', 'row']">
          <div *ngFor="let game of featured; let i = index">
            <div [ngClass]="{'loadingGame' : startedGameID === game.NameID}" class="game--item" (click)="runGame(game.NameID, game.MinBet, game.Images.background);" (mouseenter)="showSparkl(game.NameID+'_'+i);" (mouseleave)="hideSparkl(game.NameID+'_'+i);">
              <div class="game--item-image home-sparkling-animation g_{{game.NameID}}">
                <span *ngIf="startedGameID === game.NameID" class="spinner"></span>
                <app-sparkling-animation *ngIf="!lotteryService.isMobile" class="sparkling-background" [(showSparkles)]="showSparkles[game.NameID+'_'+i]"></app-sparkling-animation>
                <span class="gameName" *ngIf="showLang">{{game.Names[showLang]}}</span>
              </div>
            </div>
        </div>
      </owl-carousel>
  </div>
  </div>
</div>
</div>
